import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNG1qMXNtMCB7CiAgd2lkdGg6IDEwNHB4OwogIGhlaWdodDogMzJweDsKICBwb3NpdGlvbjogcmVsYXRpdmU7Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNG1qMXNtMSB7CiAgd2lkdGg6IDEwNHB4Owp9';
export var wrapperStyle = '_14mj1sm0';
export var svgStyle = '_14mj1sm1';